<template>
    <CRow>
        <CCol col="12" lg="8">
            <CCard>
                <CCardHeader>
                    <strong>{{ service.title }}: {{ promotion.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <PromotionsTabLinks :service-name="serviceName" />

                    <CRow class="ml-1 mt-3">
                        <p>Требования к файлу импорта клиентов:</p>
                    </CRow>
                    <CRow class="ml-1">
                        <ul>
                            <li> - Формат - CSV</li>
                            <li> - Разделитель - ";"</li>
                            <li> - Значения указываются без кавычек</li>
                            <li> - Кодировка файла - "UTF-8"</li>
                        </ul>
                    </CRow>
                    <CRow class="ml-1 mt-3">
                        <p>Последовательность значений в файле:</p>
                    </CRow>
                    <CRow class="ml-1 mb-4">
                        <ul>
                            <li>1. Имя</li>
                            <li>2. Номер телефона</li>
                            <li>3. Размер скидки (необязательно)</li>
                            <li>4. Время начала действия скидки (необязательно)</li>
                            <li>5. Время окончания действия скидки (необязательно)</li>
                        </ul>
                    </CRow>
          
                    <CForm>
                        <CInputFile
                            ref="picture"
                            label="Выберите файл"
                            horizontal
                            class="mt-3"
                            @change="selectPicture"
                        />
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="executeImport"
                    >Импорт</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PromotionsTabLinks from '@/components/promotions/PromotionsTabLinks';
    import { getRouteName } from '../../utils/route-name';

    export default {
        name: 'PromotionImport',

        components: {
            PromotionsTabLinks,
        },

        data() {
            return {
                serviceName: getRouteName(this.$router.currentRoute.path),
                service: {},
                promotion: {},
                selectedPicture: null,
            };
        },

        computed: {},

        mounted() {
            const serviceId = parseInt(this.$route.params.id);
            const promotionId = parseInt(this.$route.params.promotion_id);
            let url = `/${this.serviceName}/${serviceId}`;

            if (this.serviceName === 'entities') {
                url = `/${this.serviceName}/get/${serviceId}`
            }
            Vue.axios
                .get(url)
                .then(resp => {
                    this.service = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get('/promotions/' + promotionId)
                .then(resp => {
                    this.promotion = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            executeImport() {
                if(!this.selectedPicture) {
                    this.$root.$emit('showError', 'Выберите файл.');
                    return;
                }
                let formData = new FormData();
                formData.append('file', this.selectedPicture);
                Vue.axios
                    .post('/files/upload-raw', formData)
                    .then(resp => {
                        Vue.axios
                            .post('/promotions/' + this.promotion.id + '/import', { filename : resp.data.filename })
                            .then(() => {
                                this.$router.push({ path: `/${this.serviceName}/${this.service.id}/promotions/${this.promotion.id}/clients` });
                            })
                            .catch(err => {
                                this.$root.$emit('showError', 'Ошибка импорта клиентов.');
                            });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки файла.');
                    });
            },

            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },
        },
    };
</script>
<style scoped>
</style>
